import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api } from "@/lib/api";

export const RESET = {
    passwordInput: "reset-password-input",
    confirmInput: "reset-confirm-input",
    submitBtn: "reset-submit-btn",
};

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [pw, setPw] = useState("");
    const [confirm, setConfirm] = useState("");
    const [busy, setBusy] = useState(false);

    async function submit(e) {
        e.preventDefault();
        if (pw !== confirm) return toast.error("Passwords don't match");
        if (!token) return toast.error("Missing token");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            toast.success("Password reset. Please sign in.");
            nav("/auth?mode=login");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4">
            <Card className="w-full max-w-md rounded-3xl border-stone-200">
                <CardContent className="p-8">
                    <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center mb-4">
                        <KeyRound className="w-5 h-5 text-emerald-700" strokeWidth={1.75} />
                    </div>
                    <h1 className="font-outfit text-2xl font-semibold text-stone-900 mb-1">Choose a new password</h1>
                    <p className="text-sm text-stone-500 font-dmsans mb-6">Minimum 8 characters.</p>

                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <Label>New password</Label>
                            <Input
                                data-testid={RESET.passwordInput}
                                type="password"
                                value={pw}
                                onChange={(e) => setPw(e.target.value)}
                                required
                                minLength={8}
                                className="mt-1.5 h-12 rounded-xl"
                            />
                        </div>
                        <div>
                            <Label>Confirm password</Label>
                            <Input
                                data-testid={RESET.confirmInput}
                                type="password"
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                required
                                minLength={8}
                                className="mt-1.5 h-12 rounded-xl"
                            />
                        </div>
                        <Button
                            data-testid={RESET.submitBtn}
                            type="submit"
                            disabled={busy}
                            className="w-full h-12 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white"
                        >
                            {busy ? "Saving…" : "Reset password"}
                        </Button>
                        <div className="text-center text-sm text-stone-500 font-dmsans">
                            <Link to="/auth?mode=login" className="text-emerald-700 hover:underline">Back to sign in</Link>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}
